// Chemin: C:\gestion-copro\src\types\coproprietaire.types.ts

import { Timestamp } from 'firebase/firestore';

/**
 * Statut du compte utilisateur d'un copropriétaire
 */
export type StatutCompteCoproprietaire = 'non_invite' | 'invite' | 'actif';

/**
 * Entité Copropriétaire
 * Représente une personne (ou entité) propriétaire d'un ou plusieurs lots
 */
export interface Coproprietaire {
  id: string;
  coproprieteId: string;
  
  // Identité
  nom: string;
  prenom?: string;
  
  // Coordonnées
  email?: string;
  telephone?: string;
  adresseCorrespondance?: string;  // Si différente de l'adresse du lot
  
  // Relation avec les lots (un copropriétaire peut posséder plusieurs lots)
  lotIds: string[];
  
  // Relation avec le compte utilisateur Firebase Auth
  userId?: string;
  statutCompte: StatutCompteCoproprietaire;
  dateInvitation?: Timestamp;
  dateActivation?: Timestamp;
  
  // Notes internes (visibles uniquement par le CS)
  notes?: string;
  
  // Métadonnées
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

/**
 * Données pour création d'un copropriétaire
 */
export interface CoproprietaireCreateData {
  coproprieteId: string;
  nom: string;
  prenom?: string;
  email?: string;
  telephone?: string;
  adresseCorrespondance?: string;
  lotIds?: string[];
  notes?: string;
}

/**
 * Données pour mise à jour d'un copropriétaire
 */
export interface CoproprietaireUpdateData {
  nom?: string;
  prenom?: string;
  email?: string;
  telephone?: string;
  adresseCorrespondance?: string;
  lotIds?: string[];
  userId?: string;
  statutCompte?: StatutCompteCoproprietaire;
  dateInvitation?: Timestamp;
  dateActivation?: Timestamp;
  notes?: string;
}

/**
 * Labels pour l'affichage du statut compte
 */
export const STATUT_COMPTE_LABELS: Record<StatutCompteCoproprietaire, string> = {
  non_invite: 'Non invité',
  invite: 'Invitation envoyée',
  actif: 'Compte actif'
};

/**
 * Couleurs pour les badges de statut
 */
export const STATUT_COMPTE_COLORS: Record<StatutCompteCoproprietaire, string> = {
  non_invite: 'bg-gray-100 text-gray-800',
  invite: 'bg-amber-100 text-amber-800',
  actif: 'bg-green-100 text-green-800'
};

/**
 * Icônes pour les statuts (classes Lucide)
 */
export const STATUT_COMPTE_ICONS: Record<StatutCompteCoproprietaire, string> = {
  non_invite: 'UserX',
  invite: 'Clock',
  actif: 'UserCheck'
};

/**
 * Vue résumée d'un copropriétaire (pour les listes)
 */
export interface CoproprietaireResume {
  id: string;
  nom: string;
  prenom?: string;
  email?: string;
  nombreLots: number;
  tantiemesTotal: number;
  statutCompte: StatutCompteCoproprietaire;
}

/**
 * Copropriétaire avec ses lots enrichis (pour l'affichage détaillé)
 */
export interface CoproprietaireAvecLots extends Coproprietaire {
  lots: {
    id: string;
    numero: string;
    type: string;
    tantiemes: number;
  }[];
  tantiemesTotal: number;
}